export default {
  name: 'ds-vuejs-wrapper',
  inheritAttrs: false,
  props: {
    ds: { type: String, required: true },
    value: { required: false }
  },
  render (h) {
    const data = {
      on: { ...this.$listeners } || {},
      attrs: { },
      domProps: this.$attrs,
    };
    const prevDsInput = data.on.dsInput;
    data.on.dsInput = (e) => {
      e.stopPropagation();
      if (prevDsInput) prevDsInput(e);
      this.$emit('update:value', e.detail);
    };
    const children = Object.keys(this.$slots).map(slot => {
      if (slot === 'default') {
        return h('slot', { name: slot }, this.$slots[slot]);
      } else {
        return h('slot', { name: slot, attrs: { slot } }, this.$slots[slot]);
      }
    });
    return h(`ds-${this.ds}`, data, children);
  },
  mounted () {
    this.$el.value = this.value;
  },
  watch: {
    value () {
      this.$el.value = this.value;
    }
  }
};
